<app-table-column name="oc" size="medium" (click)="handleOpenModal()">
  <span content>{{ order.orderNumber }}</span>
</app-table-column>

<app-table-column name="in-timestamp" size="small" (click)="handleOpenModal()">
  <span content>{{ order.issuedAt | date: 'dd/MM/yyyy - HH:mm' }}</span>
</app-table-column>

<app-table-column name="document" size="small" (click)="handleOpenModal()">
  <span content>{{ translateEntrySource(order.entrySource) }}</span>
</app-table-column>

<app-table-column name="status" size="small" (click)="handleOpenModal()">
  <span content>{{ translateStatus(order.state) }}</span>
</app-table-column>
